module.exports = __webpack_public_path__ + "static/media/tanqueone.544b4e1a.jpg";